(() => {
  function init() {
    document.querySelectorAll('#shg-products, #shg-bestsellers').forEach(section => {
      if (section.dataset.interactionsReady) return;
      section.dataset.interactionsReady = 'true';
      const wrapper = section.querySelector('.shg-carousel-wrapper');
      const controls = section.querySelector('.shg-carousel-controls');
      if (controls) wrapper.append(controls);
      const media = section.querySelector('.shg-card-media-wrap');
      const resize = new ResizeObserver(() => wrapper.style.setProperty('--shg-media-center', `${media.clientHeight / 2}px`));
      if (media) resize.observe(media);

      const dialog = document.createElement('dialog');
      dialog.className = 'shg-quickview-dialog';
      dialog.setAttribute('aria-label', 'Ürüne hızlı bakış');
      dialog.innerHTML = '<button type="button" class="shg-quickview-close" aria-label="Kapat">×</button><div class="shg-quickview-layout"><img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" width="600" height="600" alt=""><div><p class="shg-quickview-category"></p><h2></h2><p class="shg-quickview-price"></p><a class="shg-quickview-detail">Ürün detaylarını incele →</a></div></div>';
      section.append(dialog);
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
      });
      let opener;
      dialog.addEventListener('close', () => opener?.focus());
      section.querySelectorAll('.shg-product-card').forEach(card => {
        const save = card.querySelector('[data-shg-wishlist-toggle]');
        const addForm = card.querySelector('[data-shg-product-form]');
        const actions = document.createElement('div');
        actions.className = 'shg-card-image-actions';
        card.querySelector('.shg-card-media-wrap').append(actions);
        save?.remove();
        if (addForm) {
          const addButton = addForm.querySelector('button[type="submit"]');
          addButton.className = 'shg-card-add-to-cart';
          const buttonText = addButton.querySelector('span');
          if (buttonText) buttonText.textContent = 'Sepete Ekle';
          actions.append(addForm);
          card.querySelector('.shg-card-quick-actions')?.remove();
        }
        const quick = document.createElement('button');
        quick.type = 'button';
        quick.className = 'shg-card-quickview';
        quick.textContent = 'Hızlı Bakış';
        quick.setAttribute('aria-haspopup', 'dialog');
        actions.append(quick);
        quick.addEventListener('click', () => {
          opener = quick;
          const title = card.querySelector('.shg-card-title').textContent.trim();
          dialog.querySelector('h2').textContent = title;
          dialog.querySelector('img').src = card.querySelector('.shg-card-img')?.src || '';
          dialog.querySelector('img').alt = title;
          dialog.querySelector('.shg-quickview-category').textContent = card.querySelector('.shg-card-category')?.textContent || '';
          dialog.querySelector('.shg-quickview-price').textContent = card.querySelector('.shg-card-price').textContent;
          dialog.querySelector('a').href = card.querySelector('.shg-card-title a').href;
          dialog.showModal();
        });
      });
      document.addEventListener('shopify:section:unload', event => {
        if (event.target.contains(section)) { resize.disconnect(); dialog.close(); }
      }, {once:true});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
